import { useMemo, useState } from 'react';

export default function useOrderedCustomRequests<T extends { id: string }>(
  customRequests: Array<T>,
) {
  const [customRequestsOrder, setCustomRequestsOrder] = useState<Array<string>>(
    [],
  );

  const orderedCustomRequests = useMemo<Array<T>>(() => {
    return [...customRequests].sort((a, b) => {
      const indexA = customRequestsOrder.indexOf(a.id);
      const indexB = customRequestsOrder.indexOf(b.id);

      // If both are in the order array, compare their indices
      if (indexA !== -1 && indexB !== -1) {
        return indexA - indexB;
      }

      // If only one is in the array, it should come first
      if (indexA !== -1) return -1;
      if (indexB !== -1) return 1;

      // If neither is in the array, maintain their relative order
      return 0;
    });
  }, [customRequests, customRequestsOrder]);

  return {
    orderedCustomRequests,
    setCustomRequestsOrder,
  };
}
